// NOT USED FOR NOW
/*fx.ns("shared", class TimeEstimator extends fx.EventDispatcher
{
    constructor(target, numFiles, averagedelay, extratime)
    {
        super();

        this._target = target;
        this._numFiles = numFiles;
        this._averagedelay = averagedelay;
        this._lastCalculatedDelay = averagedelay;
        this._extratime = extratime;
        this._delays = [];
        this._fileIndex = 0;
        this._calculatedTotal = 0;
        this._calculatedRemaining = 0;

        this._updateEstimations();
        
        // start
        // stop
        this.on("request-started", this._onStarted, this._target);
        this.on("request-finished", this._onFinished, this._target);
    }

    get target()
    {
        return this._target;
    }

    get numFiles()
    {
        return this._numFiles;
    }

    set numFiles(val)
    {
        this._numFiles = val;
        this._updateEstimations();
    }

    get extratime()
    {
        return this._extratime;
    }

    set extratime(val)
    {
        this._extratime = val;
        this._updateEstimations();
    }

    get timeRemaining()
    {
        return this._format( this._calculatedRemaining );
    }

    get totalTime()
    {
        return this._format( this._calculatedTotal );
    }

    get progress()
    {
        return this._calculatedRemaining * 100 / this._calculatedTotal;
    }


    _updateEstimations()
    {
        this._calculatedTotal = this._extratime;
        
        for( let i = 0; i < this._fileIndex; i++)
            this._calculatedTotal += this._delays[i];

        let averageDelay = this._calculatedTotal / this._delays.length;

        this._calculatedRemaining = (this.numFiles - this._fileIndex) * averageDelay;

        if (this._fileIndex < this.numFiles)
            this._calculatedTotal += this._calculatedRemaining;

        this.trigger("updated");
    }

    _onStarted()
    {
        this._startTimeStamp = new Date();
    }

    _onFinished()
    {
        this._lastCalculatedDelay = new Date() - this._startTimeStamp;
        this._delays.push(this._lastCalculatedDelay);
        this._fileIndex++;

        this._updateEstimations();
    } 

    _format(miliseconds)
    {
        let seconds = Math.floor(miliseconds / 1000);

        //if (seconds < 60)
        //    return this._zero(seconds);

        let minutes = Math.floor(miliseconds / 1000 / 60);

        if (minutes < 60)
            return this._zero(minutes) + ":" + this._zero(seconds - (minutes * 60));

        let hours = Math.floor(miliseconds / 1000 / 60 / 60);
        
        if (hours < 24)
            return this._zero(hours) + ":" + this._zero(minutes - (hours * 60)) + ":" + this._zero(seconds - (minutes * 60));

        let days = Math.floor(miliseconds / 1000 / 60 / 60 / 24);
        
        return days + " jours et " + Math.round(hours - (days * 24)) + " heures et " + Math.round(minutes - (hours * 60)) + " minutes";
    }

    _zero(val)
    {
        val = Math.round(val);
        return (val < 10) ? ("0" + val) : val;

    }


});
*/